import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/define/test/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/define/test/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/define/test/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/define/test/submit', params,options)

export const update = (params, options) =>
request.post('/api/define/test/submit', params,options)

//获取分页表头数据
export const getTableStructure = (params, options) =>
  request.get('/api/define/test/list-structure', Object.assign({}, options, { params }));

//新增表单数据
export const submitFormData = (params, options) => request.post('/api/define/test/saveData', params, options);
